<template>
  <b-form novalidate @submit.prevent="submit" class="ml-auto mr-auto">
    <b-row>
      <b-col v-if="showError" class="col-12 col-md-6 mb-3">
        <b-card>
          <p v-if="showError === 'save'" class="text-center">{{ $t('note.form.error') }}</p>
          <p v-if="showError === 'not found'" class="text-center">{{ $t('note.form.not_found') }}</p>
        </b-card>
      </b-col>
    </b-row>
    <template v-if="showError !== 'not found'">
      <b-form-group label-for="date">
        <datepicker format="dd.MM.yyyy" :language="de" :placeholder="$t('note.form.date.label')" :input-class="{ 'with-placeholder': !form.date, 'bg-light': true }" id="date" v-model="form.date" :bootstrap-styling="true" required :state="$v.form.date.$dirty ? !$v.form.date.$error : null" @blur="$v.form.date.$touch"></datepicker>
      </b-form-group>
      <b-form-textarea :style="{ height: textAreaHeight + 'px' }" @input="resizeTextarea" ref="noteText" v-model="form.text" class="mb-3" :placeholder="$t('note.form.text.label')"></b-form-textarea>
      <b-row v-if="loading">
        <b-col class="col-12 mb-3">
          <div class="d-flex justify-content-around flex-row mb-3"><b-spinner></b-spinner></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="col-12 col-md-6 mb-3">
          <b-link class="bg-transparent h-100 text-primary border-primary border form-control text-center" :title="$t('note.form.cancel')" :to="'/colony/' + colony + '/' + apiary">
            {{ $t('note.form.cancel') }}
          </b-link>
        </b-col>
        <b-col class="col-12 col-md-6 mb-3">
          <b-button class="d-block w-100 h-100" type="submit" variant="primary">{{ $t('note.form.submit') }}</b-button>
        </b-col>
      </b-row>
      <b-row v-if="id">
        <b-col class="col-12 col-md-6"></b-col>
        <b-col class="col-12 col-md-6">
          <b-button @click="clickDelete" class="d-block h-100 w-100 bg-transparent text-primary border-primary border" :title="$t('note.form.delete')">
            {{ $t('note.form.delete') }}
          </b-button>
        </b-col>
      </b-row>
      <b-modal v-if="id" :id="'confirmNoteDelete_'+ id" centered hide-header-close @ok="doDelete" class="delete-container">
        <template slot="modal-title">
          {{ $t('note.confirm_delete.title') }}
        </template>
        {{ $t('note.confirm_delete.text') }}
        <template slot="modal-footer" slot-scope="{ ok, cancel }">
          <b-button size="lg" class="ml-auto" @click="cancel()">
            {{ $t('note.confirm_delete.no') }}
          </b-button>
          <b-button size="lg" class="mr-auto" @click="ok()">
            {{ $t('note.confirm_delete.yes') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="'offLineModalNoteDelete'" centered hide-header-close @ok="hideModal" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
      <b-modal :id="'offLineModalNoteSave'" centered hide-header-close @ok="hideModalSave" class="network-modal">
        <template slot="modal-title">
          {{ $t('offLineModal.title') }}
        </template>
        {{ $t('offLineModal.text') }}
        <template slot="modal-footer" class="offline-modal-footer" slot-scope="{ ok }">
          <b-button size="lg" class="mt-3" @click="ok()">
            {{ $t('offLineModal.ok') }}
          </b-button>
        </template>
      </b-modal>
    </template>
  </b-form>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { de } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'NoteForm',
  props: ['id', 'colony', 'apiary'],
  components: {
    Datepicker: Datepicker
  },
  data () {
    const form = {
      date: new Date(),
      text: null
    }

    return {
      de: de,
      showError: false,
      loading: false,
      form,
      textAreaHeight: null
    }
  },
  methods: {
    showOffLineModalSave () {
      this.$bvModal.show('offLineModalNoteSave')
    },
    hideModalSave () {
      this.$bvModal.hide('offLineModalNoteSave')
    },
    showOffLineModal () {
      this.$bvModal.show('offLineModalNoteDelete')
    },
    hideModal () {
      this.$bvModal.hide('offLineModalNoteDelete')
    },
    resizeTextarea () {
      this.textAreaHeight = this.$refs.noteText.$el.scrollHeight
    },
    async clickDelete () {
      if (navigator.onLine) {
        this.showModal()
      } else {
        this.showOffLineModal()
      }
    },
    showModal () {
      this.$bvModal.show('confirmNoteDelete_' + this.id)
    },
    async submit () {
      if (navigator.onLine) {
        this.$v.form.$touch()
        if (!this.$v.$error) {
          this.loading = true
          const result = await this.saveNote()
          this.loading = false
          this.showError = (!result ? 'save' : false)

          if (result) {
            this.$router.replace('/colony/' + this.colony + '/' + this.apiary)
          }

          return result
        } else {
          this.loading = false
          return false
        }
      } else {
        this.showOffLineModalSave()
      }
    },
    async doDelete () {
      let result
      try {
        this.loading = true
        const token = await this.$api.user.getToken()
        result = await this.$api.notes.delete({
          id: this.id,
          colony: this.colony,
          token
        })
        this.loading = false
        if (result) {
          this.$router.replace('/colony/' + this.colony + '/' + this.apiary)
        }
        return result
      } catch (e) {
        if (e.response && e.response.status === 403) {
          this.loading = false
          this.$router.replace('/login')
        }
        return false
      }
    },
    async saveNote () {
      try {
        const token = await this.$api.user.getToken()
        return await this.$api.notes.save({
          id: this.id,
          colony: this.colony,
          date: moment(this.form.date).format('YYYY[-]MM[-]DD'),
          text: this.form.text,
          token
        })
      } catch (e) { // network error etc.
        if (e.response && e.response.status === 403) {
          this.$router.replace('/login')
        }

        return false
      }
    },
    async loadData () {
      if (this.id) {
        try {
          const data = await this.$api.notes.getOne(this.id)
          this.form.date = (data.date && Date.parse(data.date)) || this.form.date
          this.form.text = data.text || this.form.text

          const vm = this
          setTimeout(function () {
            vm.resizeTextarea()
          }, 0)

          return data
        } catch (e) {
          this.showError = 'not found'
        }
      }

      return null
    }
  },
  validations: {
    form: {
      date: {
        required
      }
    }
  },
  mounted () {
    this.loadData()
  }
}
</script>

<style scoped>
  form {
    max-width: 500px;
    font-family: "Roboto Condensed", sans-serif;
  }
</style>
